import { Component, OnInit, DoCheck, ViewChild } from '@angular/core';
//SERVICIO
import { SaleService } from '../../../service/sale.service';
//ROUTER
import { Router, ActivatedRoute, Params } from '@angular/router';

//DATATABLE
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

//MODELO
import { Sales } from '../../../model/sale.model';

//RXJS
import { Observable, BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-sale-details',
  templateUrl: './sale-details.component.html',
  styleUrls: ['./sale-details.component.css'],
})
export class SaleDetailsComponent implements OnInit, DoCheck {
  subject: BehaviorSubject<Sales[]> = new BehaviorSubject<any>([]);
  array$: Observable<any> = this.subject.asObservable();
  listData: MatTableDataSource<Sales>;
  public windowSize: any;
  displayedColumns: string[] = [
    'name',
    'persons',
    'hour',
    'finalPrice',
    'createdAt',
  ];

  displayedMobileColumns: string[] = ['information'];

  searchKey: string;
  //Directives
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public saleservice: SaleService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this._route.params.subscribe((params) => {
      const route_empresa = params['empresa'];

      this.saleservice.getSales().subscribe((res) => {
        res.map((item) => {
          const sale = item.payload.val();

          this.addElementToObservableArray(sale);

          console.log(item.payload.val());
        });
      });
    });

    // rxjs handle payload observable
    this.array$
      .pipe(
        map((res) => {
          return res;
        })
      )
      .subscribe((final: any) => {
        const data = final;
        const sales = [];
        this._route.params.subscribe((params) => {
          const route_empresa = params['empresa'].split('_')[0];
          data.map((sale) => {
            const link = sale.nameAgency.split(' ')[0];

            if (link === route_empresa) {
              sales.push(sale);
            }
          });
        });

        setTimeout(() => {
          this.listData = new MatTableDataSource(sales);
          this.listData.sort = this.sort;
          this.listData.paginator = this.paginator;
          console.log(sales);
        }, 200);
      });
  }

  ngOnInit(): void {}

  ngDoCheck() {
    this.onResize();
  }

  onSearchClear() {
    this.searchKey = '';
    this.applyFilter();
  }

  applyFilter() {
    this.listData.filter = this.searchKey.trim().toLowerCase();
  }

  addElementToObservableArray(item) {
    this.array$.pipe(take(1)).subscribe((val) => {
      // console.log(val);
      const newArr = [...val, item];
      this.subject.next(newArr);
    });
  }

  onResize() {
    this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    //console.log(this.windowSize);
  }
}
